import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { BucketFormComponent } from '@zaoblako/web/modules/admin/dumbs/bucket-form/bucket-form.component';
import { BudgetClassificationCodeFormComponent } from '@zaoblako/web/modules/admin/dumbs/budget-classification-code-form/budget-classification-code-form.component';
import { ChangelogFormComponent } from '@zaoblako/web/modules/admin/dumbs/changelog-form/changelog-form.component';
import { CurrencyFormComponent } from '@zaoblako/web/modules/admin/dumbs/currency-form/currency-form.component';
import { Extension1cFormComponent } from '@zaoblako/web/modules/admin/dumbs/extension1c-form/extension1c-form.component';
import { PayerStatusFormComponent } from '@zaoblako/web/modules/admin/dumbs/payer-status-form/payer-status-form.component';
import { RatePlanFormComponent } from '@zaoblako/web/modules/admin/dumbs/rate-plan-form/rate-plan-form.component';
import { RevenueAdminFormComponent } from '@zaoblako/web/modules/admin/dumbs/revenue-admin-form/revenue-admin-form.component';
import { StorageFormComponent } from '@zaoblako/web/modules/admin/dumbs/storage-form/storage-form.component';
import { BalanceCustomRowFormComponent } from '@zaoblako/web/modules/budget/dumbs/balance-custom-row-form/balance-custom-row-form.component';
import { BalanceReportFormatFormComponent } from '@zaoblako/web/modules/budget/dumbs/balance-report-format-form/balance-report-format-form.component';
import { BudgetTaskFormSidebarComponent } from '@zaoblako/web/modules/budget/dumbs/budget-task-form-sidebar/budget-task-form-sidebar.component';
import { PlanningScenarioFormComponent } from '@zaoblako/web/modules/budget/dumbs/planning-scenario-form/planning-scenario-form.component';
import { BannerFormComponent } from '@zaoblako/web/modules/client/dumbs/banner-form/banner-form.component';
import { ClientFormComponent } from '@zaoblako/web/modules/client/dumbs/client-form/client-form.component';
import { ContractFormComponent } from '@zaoblako/web/modules/client/dumbs/contract-form/contract-form.component';
import { ContragentFormComponent } from '@zaoblako/web/modules/client/dumbs/contragent-form/contragent-form.component';
import { CompanyFormComponent } from '@zaoblako/web/modules/company/dumbs/company-form/company-form.component';
import { CompanyGroupFormComponent } from '@zaoblako/web/modules/company/dumbs/company-group-form/company-group-form.component';
import { Database1cFormComponent } from '@zaoblako/web/modules/company/dumbs/database1c-form/database1c-form.component';
import { ConverterFormComponent } from '@zaoblako/web/modules/control/dumbs/converter-form/converter-form.component';
import { NetPingDeviceFormComponent } from '@zaoblako/web/modules/control/dumbs/net-ping-device-form/net-ping-device-form.component';
import { PassageOrderFormComponent } from '@zaoblako/web/modules/control/dumbs/passage-order-form/passage-order-form.component';
import { PassageTaskFormComponent } from '@zaoblako/web/modules/control/dumbs/passage-task-form/passage-task-form.component';
import { DealFormSidebarComponent } from '@zaoblako/web/modules/deal/dumbs/deal-form-sidebar/deal-form-sidebar.component';
import { DealGroupFormComponent } from '@zaoblako/web/modules/deal/dumbs/deal-group-form/deal-group-form.component';
import { DealTypeFormComponent } from '@zaoblako/web/modules/deal/dumbs/deal-type-form/deal-type-form.component';
import { DebtCollectionTaskFormComponent } from '@zaoblako/web/modules/debts/dumbs/debt-collection-task-form/debt-collection-task-form.component';
import { ExclusionFormComponent } from '@zaoblako/web/modules/debts/dumbs/exclusion-form/exclusion-form.component';
import { NewsletterFormSidebarComponent } from '@zaoblako/web/modules/debts/dumbs/newsletter-form-sidebar/newsletter-form-sidebar.component';
import { NewsletterTemplateFormSidebarComponent } from '@zaoblako/web/modules/debts/dumbs/newsletter-template-form-sidebar/newsletter-template-form-sidebar.component';
import { AiAgentFormComponent } from '@zaoblako/web/modules/directory/dumbs/ai-agent-form/ai-agent-form.component';
import { AiKnowledgeBaseFormComponent } from '@zaoblako/web/modules/directory/dumbs/ai-knowledge-base-form/ai-knowledge-base-form.component';
import { ApprovalSchemeFormComponent } from '@zaoblako/web/modules/directory/dumbs/approval-scheme-form/approval-scheme-form.component';
import { CostCenterFormComponent } from '@zaoblako/web/modules/directory/dumbs/cost-center-form/cost-center-form.component';
import { DirectionFormComponent } from '@zaoblako/web/modules/directory/dumbs/direction-form/direction-form.component';
import { DirectionGroupFormComponent } from '@zaoblako/web/modules/directory/dumbs/direction-group-form/direction-group-form.component';
import { DocumentTypeFormComponent } from '@zaoblako/web/modules/directory/dumbs/document-type-form/document-type-form.component';
import { FilialFormComponent } from '@zaoblako/web/modules/directory/dumbs/filial-form/filial-form.component';
import { NomenclatureFormComponent } from '@zaoblako/web/modules/directory/dumbs/nomenclature-form/nomenclature-form.component';
import { NomenclatureGroupFormComponent } from '@zaoblako/web/modules/directory/dumbs/nomenclature-group-form/nomenclature-group-form.component';
import { OperationTypeErp1cFormComponent } from '@zaoblako/web/modules/directory/dumbs/operation-type-erp-1c-form/operation-type-erp-1c-form.component';
import { OperationTypeFormComponent } from '@zaoblako/web/modules/directory/dumbs/operation-type-form/operation-type-form.component';
import { ProjectMasterMilestoneFormComponent } from '@zaoblako/web/modules/directory/dumbs/project-master-milestone-form/project-master-milestone-form.component';
import { RoomFormComponent } from '@zaoblako/web/modules/directory/dumbs/room-form/room-form.component';
import { UnitFormComponent } from '@zaoblako/web/modules/directory/dumbs/unit-form/unit-form.component';
import { DocumentFormSidebarComponent } from '@zaoblako/web/modules/document/dumbs/document-form-sidebar/document-form-sidebar.component';
import { DocumentRegulationFormComponent } from '@zaoblako/web/modules/document/dumbs/document-regulation-form/document-regulation-form.component';
import { DocumentSalaryDistributionFormComponent } from '@zaoblako/web/modules/document/dumbs/document-salary-distribution-form/document-salary-distribution-form.component';
import { DocumentSalaryAccrualFormComponent } from '@zaoblako/web/modules/document/dumbs/document-salary-accrual-form/document-salary-accrual-form.component';
import { DocumentTemplateFormComponent } from '@zaoblako/web/modules/document/dumbs/document-template-form/document-template-form.component';
import { HelpdeskAcceptTaskFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-accept-task-form/helpdesk-accept-task-form.component';
import { EavEntityTypeFormComponent } from '@zaoblako/web/modules/directory/dumbs/eav-entity-type-form/eav-entity-type-form.component';
import { HelpdeskTaskFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-task-form/helpdesk-task-form.component';
import { HelpdeskTaskTypeFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-task-type-form/helpdesk-task-type-form.component';
import { HelpdeskTemplateFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-template-form/helpdesk-template-form.component';
import { LkEuExternalUserEditFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/external-user-edit-form/lk-eu-external-user-edit-form.component';
import { LkEuHelpdeskTaskFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/helpdesk-task-form/lk-eu-helpdesk-task-form.component';
import { LkEuPassageOrderFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/passage-order-form/lk-eu-passage-order-form.component';
import { LkEuPassageTaskFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/passage-task-form/lk-eu-passage-task-form.component';
import { LkEuResidentCarFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/resident-car-form/lk-eu-resident-car-form.component';
import { LkEuTransitTaskFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/transit-task-form/lk-eu-transit-task-form.component';
import { LkEuExternalUserCreateFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/external-user-create-form/lk-eu-external-user-create-form.component';
import { KktFormComponent } from '@zaoblako/web/modules/ofd/dumbs/kkt-form/kkt-form.component';
import { TypeOfActivityFormComponent } from '@zaoblako/web/modules/ofd/dumbs/type-of-activity-form/type-of-activity-form.component';
import { HikvisionCameraFormComponent } from '@zaoblako/web/modules/passage/dumbs/hikvision-camera-form/hikvision-camera-form.component';
import { ResidentCarFormComponent } from '@zaoblako/web/modules/passage/dumbs/resident-car-form/resident-car-form.component';
import { TransitTaskFormComponent } from '@zaoblako/web/modules/passage/dumbs/transit-task-form/transit-task-form.component';
import { PaymentStatusFormComponent } from '@zaoblako/web/modules/payments/dumbs/payment-status-form/payment-status-form.component';
import { PlannedIncomeFormComponent } from '@zaoblako/web/modules/payments/dumbs/planned-income-form/planned-income-form.component';
import { TaskFormSidebarComponent } from '@zaoblako/web/modules/payments/dumbs/task-form-sidebar/task-form-sidebar.component';
import { TaskScenarioFormComponent } from '@zaoblako/web/modules/payments/dumbs/task-scenario-form/task-scenario-form.component';
import { TaskTemplateFormComponent } from '@zaoblako/web/modules/payments/dumbs/task-template-form/task-template-form.component';
import { ProjectFormComponent } from '@zaoblako/web/modules/project/dumbs/project-form/project-form.component';
import { ProjectTemplateFormComponent } from '@zaoblako/web/modules/project/dumbs/project-template-form/project-template-form.component';
import { AccessCardFormComponent } from '@zaoblako/web/modules/security/dumbs/access-card-form/access-card-form.component';
import { ExternalUserCreateFormComponent } from '@zaoblako/web/modules/security/dumbs/external-user-create-form/external-user-create-form.component';
import { ExternalUserEditFormComponent } from '@zaoblako/web/modules/security/dumbs/external-user-edit-form/external-user-edit-form.component';
import { RoleFormComponent } from '@zaoblako/web/modules/security/dumbs/role-form/role-form.component';
import { ScheduleFormComponent } from '@zaoblako/web/modules/security/dumbs/schedule-form/schedule-form.component';
import { UserCreateFormComponent } from '@zaoblako/web/modules/security/dumbs/user-create-form/user-create-form.component';
import { UserDelegationFormComponent } from '@zaoblako/web/modules/security/dumbs/user-delegation-form/user-delegation-form.component';
import { UserEditFormComponent } from '@zaoblako/web/modules/security/dumbs/user-edit-form/user-edit-form.component';
import { UserGroupFormComponent } from '@zaoblako/web/modules/security/dumbs/user-group-form/user-group-form.component';
import { TrafficAdapterFormComponent } from '@zaoblako/web/modules/traffic/dumbs/traffic-adapter-form/traffic-adapter-form.component';
import { TypeFormEnum } from '@zaoblako/web/shared/components/form-sidebar/enums/type.form.enum';
import { FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { SharedModule } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DocumentFileTemplateFormComponent } from '@zaoblako/web/modules/directory/dumbs/document-file-template-form/document-file-template-form.component';
import { DocumentFileTemplateKeyFormComponent } from '@zaoblako/web/modules/directory/dumbs/document-file-template-key-form/document-file-template-key-form.component';
import { GroupPlannedIncomeFormComponent } from '@zaoblako/web/modules/payments/dumbs/group-planned-income-form/group-planned-income-form.component';
import { GroupContractFormComponent } from '@zaoblako/web/modules/client/dumbs/group-contract-form/group-contract-form.component';
import { VoiceAssistantModalComponent } from '@zaoblako/web/shared/voice-assistant/components/modal/voice-assistant-modal.component';
import { DealStatusFormComponent } from '@zaoblako/web/modules/deal/dumbs/deal-status-form/deal-status-form.component';
import { NetPingDeviceBarrierStatusComponent } from '@zaoblako/web/shared/dumbs/net-ping-device-barrier-status/net-ping-device-barrier-status.component';

@Component({
  selector: 'crm-form-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    BudgetTaskFormSidebarComponent,
    SidebarModule,
    SharedModule,
    CheckboxModule,
    VoiceAssistantModalComponent,
    FormsModule,
    RatePlanFormComponent,
    ContragentFormComponent,
    PlannedIncomeFormComponent,
    DirectionFormComponent,
    DirectionGroupFormComponent,
    UnitFormComponent,
    FilialFormComponent,
    DocumentTypeFormComponent,
    OperationTypeFormComponent,
    OperationTypeErp1cFormComponent,
    ProjectMasterMilestoneFormComponent,
    ApprovalSchemeFormComponent,
    TaskFormSidebarComponent,
    Database1cFormComponent,
    CompanyFormComponent,
    CompanyGroupFormComponent,
    ClientFormComponent,
    UserCreateFormComponent,
    UserEditFormComponent,
    UserGroupFormComponent,
    RoleFormComponent,
    ScheduleFormComponent,
    Extension1cFormComponent,
    ChangelogFormComponent,
    DealGroupFormComponent,
    DealFormSidebarComponent,
    DealTypeFormComponent,
    DebtCollectionTaskFormComponent,
    ExclusionFormComponent,
    NewsletterFormSidebarComponent,
    NewsletterTemplateFormSidebarComponent,
    HelpdeskTaskFormComponent,
    HelpdeskTemplateFormComponent,
    HelpdeskTaskTypeFormComponent,
    ProjectFormComponent,
    ProjectTemplateFormComponent,
    BalanceCustomRowFormComponent,
    BalanceReportFormatFormComponent,
    PaymentStatusFormComponent,
    TaskTemplateFormComponent,
    DocumentFormSidebarComponent,
    DocumentTemplateFormComponent,
    DocumentRegulationFormComponent,
    TooltipModule,
    RoomFormComponent,
    ContractFormComponent,
    DocumentSalaryDistributionFormComponent,
    DocumentSalaryAccrualFormComponent,
    NomenclatureFormComponent,
    NomenclatureGroupFormComponent,
    ConverterFormComponent,
    AccessCardFormComponent,
    KktFormComponent,
    TypeOfActivityFormComponent,
    ExternalUserCreateFormComponent,
    ExternalUserEditFormComponent,
    HelpdeskAcceptTaskFormComponent,
    LkEuHelpdeskTaskFormComponent,
    CostCenterFormComponent,
    TrafficAdapterFormComponent,
    PayerStatusFormComponent,
    BudgetClassificationCodeFormComponent,
    RevenueAdminFormComponent,
    CurrencyFormComponent,
    TaskScenarioFormComponent,
    TransitTaskFormComponent,
    LkEuTransitTaskFormComponent,
    ResidentCarFormComponent,
    EavEntityTypeFormComponent,
    NetPingDeviceFormComponent,
    HikvisionCameraFormComponent,
    PlanningScenarioFormComponent,
    LkEuResidentCarFormComponent,
    UserDelegationFormComponent,
    StorageFormComponent,
    BucketFormComponent,
    BannerFormComponent,
    PassageTaskFormComponent,
    LkEuPassageTaskFormComponent,
    AiAgentFormComponent,
    AiKnowledgeBaseFormComponent,
    LkEuExternalUserCreateFormComponent,
    LkEuExternalUserEditFormComponent,
    LkEuPassageOrderFormComponent,
    PassageOrderFormComponent,
    DocumentFileTemplateFormComponent,
    DocumentFileTemplateKeyFormComponent,
    GroupPlannedIncomeFormComponent,
    GroupContractFormComponent,
    DealStatusFormComponent,
    NetPingDeviceBarrierStatusComponent
  ],
  templateUrl: './form-sidebar.component.html',
  styleUrls: ['./form-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class FormSidebarComponent implements OnInit {
  /** Личный кабинет external-user: без голосового помощника в футере форм */
  @Input() public isLk = false;

  public forms$: Observable<FormType[]>;

  public get TypeFormEnum() {
    return TypeFormEnum;
  }

  public constructor(
    private readonly formStoreService: FormStoreService,
    private readonly renderer: Renderer2,
    private readonly route: ActivatedRoute,
    private readonly errorService: ErrorService
  ) {}

  public ngOnInit(): void {
    this.forms$ = this.formStoreService
      .select((state) => state.forms)
      .pipe(
        tap((forms) => {
          forms.forEach((form, index) => {
            if (!form.isShowSidebar) {
              return;
            }
            setTimeout(() => {
              const mask = document.querySelectorAll('.p-sidebar-mask');
              const sidebars = document.querySelectorAll('.p-sidebar');
              if (form.typeZIndex === 'z-index-2000') {
                if (mask[index]) {
                  this.renderer.setStyle(mask[index], 'z-index', 1999, 1);
                }
                return;
              }
              if (mask[index]) {
                this.renderer.setStyle(mask[index], 'z-index', 1100 + index * 2, 1);
              }
              if (sidebars[index]) {
                this.renderer.setStyle(sidebars[index], 'z-index', 1101 + index * 2, 1);
              }
            });
          });
        })
      );
  }

  public closeSidebar(visible: boolean, index: number) {
    if (!visible) {
      this.formStoreService.closeSidebar(index);
    }
  }

  public toggleIsRedirectInCreate(value: boolean, index: number) {
    this.formStoreService.toggleIsRedirectInCreate(value, index);
  }

  public entityId(index: number) {
    return this.formStoreService.getState.forms[index]?.entityId;
  }

  public shareLinkForm(index: number) {
    let params: HttpParams = new HttpParams();
    Object.keys(this.route.snapshot.queryParams).forEach((key) => {
      params = params.append(key, this.route.snapshot.queryParams[key]);
    });
    params = params.append('formType', this.formStoreService.getState.forms[index].type);
    params = params.append('formId', this.formStoreService.getState.forms[index].entityId);
    params = params.append('formHeaderText', this.formStoreService.getState.forms[index].headerText);
    params = params.append('formWidthSize', this.formStoreService.getState.forms[index].widthSize);
    params = params.append('formIsShowDelete', this.formStoreService.getState.forms[index].isShowDelete);
    params = params.append('formIsShowShare', this.formStoreService.getState.forms[index].isShowShare);
    params = params.append('formTypeZIndex', this.formStoreService.getState.forms[index].typeZIndex);
    const url = window.location.origin + window.location.pathname + '?' + params.toString();
    navigator.clipboard
      .writeText(url)
      .then(() => {
        this.errorService.addSuccessMessage('Ссылка скопирована');
      })
      .catch(console.error);
  }
}
